import { createContext, useState } from "react";

export const EditFlagContext = createContext();

const EditFlagProvider = ({ children }) => {
  const [editFlag, setEditFlag] = useState(false);
  const collectData = (data) => {
    setEditFlag(data);
  };

  return (
    <EditFlagContext.Provider
      value={{
        editFlag,
        collectData,
      }}
    >
      {children}
    </EditFlagContext.Provider>
  );
};
export default EditFlagProvider;
